var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgService8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_595_10789)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 80,
    height: 80,
    rx: 15,
    fill: "#D60921"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 28.5H31.5C30.7044 28.5 29.9413 28.8161 29.3787 29.3787C28.8161 29.9413 28.5 30.7044 28.5 31.5V34.5H61.5V31.5C61.5 30.7044 61.1839 29.9413 60.6213 29.3787C60.0587 28.8161 59.2956 28.5 58.5 28.5ZM33 33C32.7033 33 32.4133 32.912 32.1666 32.7472C31.92 32.5824 31.7277 32.3481 31.6142 32.074C31.5006 31.7999 31.4709 31.4983 31.5288 31.2074C31.5867 30.9164 31.7296 30.6491 31.9393 30.4393C32.1491 30.2296 32.4164 30.0867 32.7074 30.0288C32.9983 29.9709 33.2999 30.0006 33.574 30.1142C33.8481 30.2277 34.0824 30.42 34.2472 30.6666C34.412 30.9133 34.5 31.2033 34.5 31.5C34.5 31.8978 34.342 32.2794 34.0607 32.5607C33.7794 32.842 33.3978 33 33 33ZM37.5 33C37.2033 33 36.9133 32.912 36.6666 32.7472C36.42 32.5824 36.2277 32.3481 36.1142 32.074C36.0006 31.7999 35.9709 31.4983 36.0288 31.2074C36.0867 30.9164 36.2296 30.6491 36.4393 30.4393C36.6491 30.2296 36.9164 30.0867 37.2074 30.0288C37.4983 29.9709 37.7999 30.0006 38.074 30.1142C38.3481 30.2277 38.5824 30.42 38.7472 30.6666C38.912 30.9133 39 31.2033 39 31.5C38.9988 31.8975 38.8404 32.2783 38.5593 32.5593C38.2783 32.8404 37.8975 32.9988 37.5 33ZM61.5 42V36H28.5V57C28.5 57.7956 28.8161 58.5587 29.3787 59.1213C29.9413 59.6839 30.7044 60 31.5 60H58.5C59.2956 60 60.0587 59.6839 60.6213 59.1213C61.1839 58.5587 61.5 57.7956 61.5 57V42Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_595_10789",
    x: 0,
    y: 0,
    width: 92,
    height: 92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_595_10789"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_595_10789"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_595_10789",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService8);
export default __webpack_public_path__ + "static/media/service-8.3c307378462d0a26dc700a32ab04d306.svg";
export { ForwardRef as ReactComponent };